import { ErrorMessage } from "@hookform/error-message";
import React, { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { validations } from "../Validations/regexValidations";

function OtherInvestmentServices() {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();
  const { append, fields, prepend } = useFieldArray({
    control,
    name: "otherInvestmentServices",
  });

  useEffect(() => {
    !fields.length && prepend({});
  }, []);

  return (
    <React.Fragment>
      {fields.map((field, index) => {
        const baseName = `otherInvestmentServices[${index}]`;
        return (
				<div key={field.id} className="mt-6 create__requisitos">
					<h4 className="create__requisitos-title">
						Otros servicios o productos de inversión contratados o adquiridos a través de
						otros participantes del mercado de valores o en el extranjero - <i>Opcional</i>
					</h4>
					<div className="lg:items-end lg:flex lg:space-x-9">
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Producto</label>
							<input
								type="text"
								maxLength={40}
								className="global-input"
								placeholder="Producto"
								{...register(`${baseName}.Product`, {
									pattern: validations.letrasYespacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.Product`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Participante</label>
							<input
								type="text"
								maxLength={40}
								className="global-input"
								placeholder="Participante"
								{...register(`${baseName}.Partaker`, {
									pattern: validations.letrasYespacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.Partaker`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
					</div>
				</div>
			);
      })}
      <div className="mt-6 mb-6 text-center create__requisitos">
        <button
          type="button"
          onClick={() => {
            append({});
          }}
          className="mb-4"
        >
          <div className="mx-auto text-[#012169] opacity-50 text-[40px]">+</div>
          <span className="text-[#012169] opacity-50 font-bold mb-3">
            Agregar otro Servicio o producto de inversión
          </span>
        </button>
      </div>
    </React.Fragment>
  );
}

export default OtherInvestmentServices;
